import {BsPlayCircle} from "react-icons/bs";
import "./playbtn.css"

export const Playbtn = () => {
    return <div >
        <BsPlayCircle id="btn"/>
    </div>
}